import React from "react";
import { Redirect} from 'react-router-dom';
import { Routes } from '../Core/Constants';
import { UserProvider } from './../Providers/UserProvider';
import { CartProvider } from './../Providers/CartProvider';

export default class Order extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            order: null,
            redirectToCart: false
          
        };
    }
    componentDidMount = () => {
      
		UserProvider.getOrder(this.props.id, (data) => {
			window.gtm.loadAccount("order");
            this.setState({ order: data });
        })

    }

    addOrderToCart = () => {
        CartProvider.addOrderToCart(this.state.order, () => {
            this.setState({ redirectToCart: true });
        });

    }

    render() {
        let order = this.state.order;
        let T = window.Texts.orders;
        if (!order)
            return <div>{T.loading}</div>;
        
        if (this.state.redirectToCart)
            return <Redirect to={Routes.Cart} />
        return (
            <div className="order-detail-page">
                <div className="cover">
                    <div className="headline">
                        <h1>{T.orderTitle + ' : ' + order.invoiceCode}</h1>
                    </div>
                    <ul className="details">
                        <li><span>{T.acceptedDay + ':'}</span>{order.created}</li>
                        <li>
                            <span>{T.state + ':'}</span>
                            {order.displayState}
                        </li>
                    </ul>
                    <table className="table">
                        <tbody>
                            {order.orderedProducts.map((orderedProduct) => {
                                return <tr>
                                    <td className="thumb">
                                        <div className="inner">
                                            <img src={orderedProduct.thumbUrl} />
                                        </div>
                                    </td>
                                    <td className="name">
                                        <div className="inner">
                                            {orderedProduct.product ?
                                                <a className="no-line underline" href={orderedProduct.product.url} title={orderedProduct.productName}>
                                                    <u>{orderedProduct.productName}</u>
                                                </a> :
                                                <div className="no-line underline">
                                                    <u>{orderedProduct.productName}</u>
                                                </div>}
                                        </div>
                                    </td>
                                    <td className="count">
                                        {orderedProduct.count} x
                        </td>
                                    <td className="price">
                                        <div className="inner">
                                            <span>{orderedProduct.priceTable.displayTotalPriceInclVat}</span>
                                            <small>{orderedProduct.priceTable.displayTotalPriceExclVat}
                                                bez DPH</small>
                                        </div>
                                    </td>
                                    <td className="remove" />
                                </tr>
                            })}
                        </tbody>
                    </table>
                    <div className="cart-summary">
                        <ul>
                            <li className="call2action" />
                            <li className="price-button">

                                <div className="price">
                                    <h4>{order.priceTable.displayTotalPriceInclVat}</h4>
                                    <p>{order.priceTable.displayTotalPriceExclVat} bez DPH</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <form name="order" method="post" onSubmit={this.addOrderToCart}>
                        <div>
                            <div className="buttons">
                                <button type="submit" className="btn btn50 iconed icon-continue AddOrderToCart">
                                    <span>{T.addOrderToCart}</span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

